<template>
  <div class="tw-font-inter tw-flex tw-flex-col tw-gap-4 tw-p-5 tw-border-dashed tw-border-2 tw-border-[#D0D4DC] tw-rounded-2xl">
    <RiskSelection />
    <ValuesSelection />
  </div>
</template>


<script>
// import SubComponent from '../components/SubComponent'
import RiskSelection from '@frontend/ui/features/checkup/components/portfolio-select/RiskSelection.vue';
import ValuesSelection from '@frontend/ui/features/checkup/components/portfolio-select/ValuesSelection.vue';

export default {
  name: 'AdvisorCoreOptions',
  components: {
    RiskSelection,
    ValuesSelection,
  },
  props: {
    // prop: { type: String, required: true },
    // prop: String,
  },
  data() {
    return { /* Local variables */ };
  },
  computed: { /*
      Creates a new property
      Updates when any dependant property changes */
  },
  watch: { /*
      Watches an existing property
      Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {},
};
</script>


  <style scoped>

  </style>
